import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'

import axios from '/node_modules/axios'
import VueAxios from 'vue-axios'

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import GlobalVariable from "./plugins/global.js"

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

import '@coreui/coreui/dist/css/coreui.min.css'

import VueCarousel from 'vue-carousel';

Vue.prototype.GLOBAL = GlobalVariable
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueToast);
Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios)
Vue.use(VideoPlayer)
Vue.use(VueCarousel);

Vue.prototype.$log = console.log.bind(console)

let instance = Vue.$toast.open('You did it!');
instance.dismiss();
Vue.$toast.clear();

router.beforeEach((to, from, next) => {

  const isLogin = localStorage.getItem('token') != undefined ;
  if( isLogin ){
    next();
  } else {
    if( to.path !== '/pages/login')
      next('/pages/login');
    else
      next();
  }
});

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
